import { PatientChatHistory, PatientSessions } from "../../api/types";
import { cn } from "@workspace/web-ui/lib/utils";

type SessionType = PatientSessions['sessions'][0];
interface ChatHistoryProps {
  selectedSession?: SessionType;
  chatHistory?: PatientChatHistory;
}

export const ChatHistory = ({ chatHistory }: ChatHistoryProps) => {
  // Combine alfie and onboard chat history if needed
  const alfieMessages = chatHistory?.chat_history?.alfie_chat_history || [];
  const onboardMessages = chatHistory?.chat_history?.onboard_chat_history || [];

  // Merge and sort by created_at (if you want both histories together)
  const allMessages = [...alfieMessages, ...onboardMessages].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  return (
    <div className="flex flex-col h-[600px] bg-white rounded-lg overflow-hidden">
      {/* Chat Header */}
      <div className="flex items-center justify-center py-3 border-b border-gray-200">
        <div className="w-full max-w-md">
          <div className="h-px bg-gray-300 mb-2"></div>
          <p className="text-center text-sm text-gray-500">Start of chat session</p>
        </div>
      </div>

      {/* Chat Messages */}
      <div className="flex-1 overflow-y-auto hide-scrollbar p-4 space-y-4">
        {allMessages.map((msg, idx) => (
          <div key={idx} className="flex flex-col">
            <div className={`flex ${msg.message.type === 'human' ? 'justify-end' : 'justify-start'} w-full`}>
              <div
                className={cn(
                  "p-4",
                  msg.message.type === 'human'
                    ? 'bg-[#F1F4F9] border-[#4272DD] border-[1px] rounded-[16px] rounded-br-[0px] w-fit max-w-[70%]'
                    : 'bg-[#F1F4F9] rounded-[16px] rounded-bl-[0px] w-fit max-w-[70%]'
                )}
                style={msg.message.type === 'ai' ? {
                  boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 2px 1px 0px rgba(0, 0, 0, 0.02), 0px 4px 2px 0px rgba(0, 0, 0, 0), 0px 7px 2px 0px rgba(0, 0, 0, 0)'
                } : {}}
              >
                <div className="flex flex-col gap-1">
                  <span className={cn(
                    "text-[15px] leading-[137%] tracking-[-1%]",
                    msg.message.type === 'human'
                      ? 'text-[#4272DD] font-medium'
                      : 'text-[#1A202C] font-normal'
                  )}>
                    {msg.message.data.content}
                  </span>
                </div>
              </div>
            </div>
            <div className={cn(
              "text-xs text-gray-400 mt-1 px-2",
              msg.message.type === 'human' ? 'text-right' : 'text-left'
            )}>
              {new Date(msg.created_at).toLocaleString()}
            </div>
          </div>
        ))}
      </div>

      {/* Chat Footer */}
      <div className="border-t border-gray-200 p-4">
        {/* <div className="flex items-center gap-2 text-sm text-gray-500">
          <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
          <span>Alfie is typing...</span>
        </div> */}
      </div>
    </div>
  );
};